import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricCard = ({ title, value, subtitle, icon, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    error: 'bg-error/10 text-error',
    accent: 'bg-accent/10 text-accent'
  };

  const trendColors = {
    up: 'text-success',
    down: 'text-error',
    neutral: 'text-muted-foreground'
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6 transition-smooth hover:elevation-md"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="caption text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground truncate">
            {value}
          </h3>
          {subtitle && (
            <p className="caption text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${colorClasses?.[color]}`}>
          <Icon name={icon} size={20} className="md:w-6 md:h-6" />
        </div>
      </div>
      {trend && (
        <div className="flex items-center gap-2">
          <Icon 
            name={trend === 'up' ? 'TrendingUp' : trend === 'down' ? 'TrendingDown' : 'Minus'} 
            size={16} 
            className={trendColors?.[trend]}
          />
          <span className={`caption font-medium ${trendColors?.[trend]}`}>
            {trendValue}
          </span>
        </div>
      )}
    </div>
  );
};

export default MetricCard;